import styles from "./customer.module.css";
import { useState, useEffect, useContext } from "react";
import { AiFillLeftCircle } from "react-icons/ai";
import { FaTrash } from "react-icons/fa";
import Modal from "./modal/Modal";
import DelModal from "./modal/DelModal";
import SendMsg from "./modal/SendMsg";
import ReportModal from "./modal/ReportModal";
import BoxCustomer from "./BoxCustomer";
// import { connection } from "../../../utils/apiConnection.ts";
// import AuthenticationContext from "Authentication/AuthenticationContext.ts";
import AuthenticationContext from "../../../context/Authentication/AuthenticationContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactPaginate from "react-paginate";
import "./customermanagement.scss";
import { BsStarHalf } from "react-icons/bs";
import { useParams } from "react-router-dom";
import useAxios from "../../../services/useAxios";

// import Loader from "utils/Loader";

const CustomerManagement = ({ setIsLoading }) => {
  const params = useParams();
  const [img, setimg] = useState("");
  const [selectedItem, setSelectedItem] = useState("");
  const [customers, setCustomers] = useState([]);
  const [update, setUpdate] = useState(false);
  const [modalUpdate, setModalUpdate] = useState(false);
  const auth = useContext(AuthenticationContext);
  const [product, setProduct] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [ChosenPeople, setchosenPeople] = useState([]);
  const [GroupWork, setgroupWork] = useState("");
  const [PageCount, setpageCount] = useState("");
  const [pageNumber, setPageNumber] = useState(0);

  //
  const { execute: Updateusers } = useAxios("api/Update_users");
  async function UpdateusersFun(item) {
    await Updateusers({
      conditions: `id/=/${item}`,
      keyvalues: `
main_status, 2
`,
    }).then((res) => {
      if (res.status == 1) {
        setUpdate((prev) => !prev);
        setchosenPeople([]);
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("عملیات انجام نشد!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }

  //
  const { execute: Updateusers2 } = useAxios("api/Update_users");
  async function UpdateusersFun2(id) {
    const date = new Date();

    await Updateusers2({
      conditions: `id/=/${id}`,
      keyvalues: `
      main_status, 2
    `,
    }).then((res) => {
      if (res.status == 1) {
        setUpdate((prev) => !prev);
        setchosenPeople([]);
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("عملیات انجام نشد!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: Insertmsgs } = useAxios("api/Insert_msgs");
  async function InsertmsgsFun(item, group, sendWith, msg, userId) {
    const date = new Date();

    await Insertmsgs({
      uid: item,
      muid: auth.userInfo.id,
      msgtxt: msg,
      sendEmail: sendWith[0] ? 1 : 0,
      sendSMS: sendWith[1] ? 1 : 0,
      mtm: date.getTime(),
    }).then((res) => {
      if (res.status == 1) {
        toast.success("پیام ارسال شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("عملیات انجام نشد!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: Insertmsgs2 } = useAxios("api/Insert_msgs");
  async function InsertmsgsFun2(group, sendWith, msg, userId) {
    const date = new Date();
    await Insertmsgs2({
      uid: userId,
      muid: auth.userInfo.id,
      msgtxt: msg,
      sendEmail: sendWith[0] ? 1 : 0,
      sendSMS: sendWith[1] ? 1 : 0,
      mtm: date.getTime(),
    }).then((res) => {
      if (res.status == 1) {
        toast.success("پیام ارسال شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("عملیات انجام نشد!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: gift_coin } = useAxios("superadminapi/gift_coin");
  async function gift_coinFun(id, coin) {
    await gift_coin({
      user_id: id,
      amount: coin,
    }).then((res) => {
      if (res.status == 1) {
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (res.status == -1) {
        toast.error("موجودی فروشگاه کافی نسیت", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: findUser } = useAxios("api/get_users");
  async function findUserFun() {
    await findUser({
      tbl_name: "left join,files,profile_pic_file_id,id",
      count: 10,
      page: pageNumber + 1,
    }).then((res) => {
      setCustomers(res.users);
    });
  }
  //
  const { execute: findUser2 } = useAxios("api/Find_users");
  async function findUserFun2() {
    await findUser2({
      fields: `count(id) as user_count`,
    }).then((res) => {
      setpageCount(res[0].user_count);
    });
  }
  //
  const { execute: Update_users3 } = useAxios("api/Update_users");
  async function Update_usersFun3(
    item,
    group,
    status,
    NewDate,
    ImgId,
    index,
    accountChange
  ) {
    await Update_users3({
      conditions: `id/=/${item}`,
      keyvalues: `
      main_status,${status == 1 ? 0 : 1}
      account_changes,${JSON.stringify(accountChange)},
      `,
    }).then((res) => {
      if (res.status == 1) {
        setUpdate(!update);
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("عملیات انجام نشد!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: Update_users4 } = useAxios("api/Update_users");
  async function Update_usersFun4(
    group,
    status,
    NewDate,
    ImgId,
    index,
    accountChange
  ) {
    await Update_users4({
      conditions: `id/=/${NewDate.users__id}`,
      keyvalues: `
        account_changes,${JSON.stringify(accountChange)},
        main_status,${status == 1 ? 0 : 1}@@
        fullname,${NewDate.fullname}@@
        mobile,${NewDate.mobile}@@
        tell,${NewDate.tell}@@
        codemeli,${NewDate.codemeli}@@
        address,${NewDate.address}@@
        bdday,${NewDate.bdday}@@
        bdmonth,${NewDate.bdmonth}@@ 
        bdyear,${NewDate.bdyear}
        ${ImgId != "" ? "@@profile_pic_file_id," + `${ImgId}` : ""}
        `,
    }).then((res) => {
      if (res.status == 1) {
        setUpdate(!update);
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.error("عملیات انجام نشد!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }

  //
  const { execute: adminedituser } = useAxios("api/adminedituser");
  async function adminedituserFun(
    status,
    tags,
    ChosenPeople,
    item,
    index,
    temp
  ) {
    await adminedituser({
      shopId: params.supplier_id,
      userIds: item,
      tagIds: temp.toString(),
      status: status == 0 ? 3 : 0,
    }).then((res) => {
      if (ChosenPeople.length == index + 1) {
        setUpdate(!update);
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: giftcoin } = useAxios("api/giftcoin");
  async function giftcoinFun(item, coin) {
    await giftcoin({
      shopId: params.supplier_id,
      userId: item,
      coin: coin,
    }).then((res) => {
      if (res.status == 1) {
        toast.success("عملیات با موفقیت انجام شد", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (res.status == -1) {
        toast.error("موجودی فروشگاه کافی نسیت", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    });
  }
  //
  const { execute: finduserNew } = useAxios("api/get_users");
  async function finduserNewFun(e) {
    await finduserNew({
      tbl_name: "left join,files,profile_pic_file_id,id",
      count: 10,
      page: e.selected + 1,
    }).then((res) => {
      setCustomers(res.users);
    });
  }

  const deleteHandler = (group, id) => {
    if (group) {
      ChosenPeople.map((item, index) => {
        UpdateusersFun(item);
      });
    } else {
      UpdateusersFun2(id);
    }
  };

  const MsgHandler = (group, sendWith, msg, userId) => {
    const date = new Date();
    if (group) {
      ChosenPeople.map((item, index) => {
        InsertmsgsFun(item, group, sendWith, msg, userId);
      });
    } else {
      InsertmsgsFun2(group, sendWith, msg, userId);
    }
  };

  const Coin = (coin, id) => {
    gift_coinFun(coin, id);
  };
  console.log("customers", customers);
  const changeHandlerDaste = (option) => {
    setCustomers((prev) => {
      let temp = [...prev];
      temp[selectedItem].barchasb = option;
      return [...temp];
    });
  };
  useEffect(() => {
    async function loadPage() {
      findUserFun();
      findUserFun2();
      setIsLoading(false);
    }
    loadPage();
  }, [update]);

  const Update = (group, status, NewDate, ImgId, index) => {
    const date = new Date().getTime();
    if (group) {
      ChosenPeople.map((item, index) => {
        let accountChange = [];
        for (const key in NewDate) {
          if (customers[index][key] != NewDate[key]) {
            accountChange.push({
              tm: date,
              fieldName: key,
              lastValue: customers[index][key],
              newxValue: NewDate[key],
            });
          }
        }

        Update_usersFun3(
          item,
          group,
          status,
          NewDate,
          ImgId,
          index,
          accountChange
        );
      });
    } else {
      let accountChange = "";
      if (customers[index]["account_changes"] != "") {
        accountChange = JSON.parse(customers[index]["account_changes"]);
        for (const key in NewDate) {
          if (customers[index][key] != NewDate[key]) {
            console.log(customers[index]["account_changes"], "js");
            accountChange.push({
              tm: date,
              fieldName: key,
              lastValue: customers[index][key],
              nexValue: NewDate[key],
            });
          }
        }
      }

      Update_usersFun4(group, status, NewDate, ImgId, index, accountChange);
    }
  };

  const UpdateGroup = (status, tags, ChosenPeople) => {
    let temp = [];
    tags.map((item, index) => {
      temp.push(item.value);
    });
    ChosenPeople.map((item, index) => {
      adminedituserFun(status, tags, ChosenPeople, item, index, temp);
    });
  };

  const Coingroup = (coin) => {
    ChosenPeople.map((item, index) => {
      giftcoinFun(item, coin);
    });
  };

  return (
    <>
      <div className="customer-manage container w-100 my-5">
        <div className="content p-1 mt-2 text-center  mx-auto multiple-operations">
          <div className="mx-auto">
            <span className="selected-number mx-1">{ChosenPeople.length}</span>{" "}
            <span>کاربر انتخاب شده</span>
          </div>

          <div className="mx-auto text-center d-flex justify-content-center mt-3">
            <div style={{ width: "150px" }}>
              <select
                className="mx-auto form-select "
                id=""
                onChange={(e) => {
                  setgroupWork(e.target.selectedIndex);
                }}
              >
                <option value="" disabled hidden selected>
                  عملیات گروهی
                </option>
                <option value="">ویرایش</option>
                <option value="">ارسال پیام</option>
                <option value="">شارژ</option>
                <option value="">حذف</option>
              </select>
            </div>

            <div className="text-center mx-2">
              <button
                className="btn btn-success "
                id="open-modal"
                data-bs-toggle="modal"
                data-bs-target={
                  GroupWork == 1 && ChosenPeople.length > 0
                    ? "#editModal2"
                    : GroupWork == 2 && ChosenPeople.length > 0
                    ? "#SendMsgModal2"
                    : GroupWork == 3 && ChosenPeople.length > 0
                    ? "#coinModal2"
                    : "#deleteModal2"
                }
                onClick={() => {
                  if (ChosenPeople.length == 0) {
                    toast.error("کاربری انتخاب نشده", {
                      position: "top-center",
                      autoClose: 2000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  } else {
                    setModalUpdate((prev) => !prev);
                  }
                }}
              >
                اجرا
              </button>
            </div>
          </div>
        </div>

        {customers.length > 0
          ? customers.map(
              (item, index) =>
                item.main_status != 2 && (
                  <div>
                    <BoxCustomer
                      item={item}
                      key={item.id}
                      customers={customers}
                      selectedItem={selectedItem}
                      setSelectedItem={setSelectedItem}
                      setCustomers={setCustomers}
                      index={index}
                      setModalUpdate={setModalUpdate}
                      setchosenPeople={setchosenPeople}
                      ChosenPeople={ChosenPeople}
                    />
                  </div>
                )
            )
          : ""}

        <div className="d-flex w-100 justify-content-center mt-4">
          {/* <Pagination
            className="mx-auto my-3"
            total={customers.length}
            pageSize={3}
            current={currentPage}
            onChange={page => {
              setCurrentPage(page);
            }}
          ></Pagination> */}
          <ReactPaginate
            forcePage={pageNumber}
            previousLabel={"قبلی"}
            nextLabel={"بعدی"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageRangeDisplayed={1}
            marginPagesDisplayed={1}
            pageCount={Math.ceil(PageCount / 10)}
            onPageChange={(e) => {
              finduserNewFun(e);
              setPageNumber(e.selected);
            }}
            containerClassName="pagination mx-auto mb-3"
            activeLinkClassName="text-white"
            activeClassName="bg-info style-activeClass"
            pageClassName="style-pageClass mx-2"
            pageLinkClassName="page-link style-page-link"
            nextClassName="border btn mx-1 px-4 py-1 style-nextClass"
            previousClassName="border btn mx-1 px-4 py-1 style-previousClass "
            nextLinkClassName="style-nextLink "
            previousLinkClassName="style-previousLink "
          />
        </div>

        {/* <!--Modal Edit--> */}
        <Modal
          index={selectedItem}
          AllTags={allTags}
          customers={customers}
          changeHandlerDaste={changeHandlerDaste}
          EditUser={setCustomers}
          modalUpdate={modalUpdate}
          Update={Update}
          Coin={Coin}
          ChosenPeople={ChosenPeople}
          UpdateGroup={UpdateGroup}
          Coingroup={Coingroup}
        />

        <ReportModal index={customers[selectedItem]} />

        {/* <!--toast notif--> */}
        <ToastContainer />

        {/* <!--Modal Trash--> */}
        <DelModal
          index={selectedItem}
          customers={customers}
          deleteHandler={deleteHandler}
        />

        {/* <!--Modal Send Message--> */}
        <SendMsg
          index={selectedItem}
          customers={customers}
          MsgHandler={MsgHandler}
          Products={product}
          modalUpdate={modalUpdate}
          ChosenPeople={ChosenPeople}
        />
      </div>
    </>
  );
};

export default CustomerManagement;
